<template>
	<div class="content" style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; position: fixed;">
		<loading />
	</div>
</template>

<script>
	export default {
		components: {
		},
		data() {
			return {
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/Checkpoint.vue